import { render, staticRenderFns } from "./CalendarDashboardStatus.vue?vue&type=template&id=53ea5f9e"
import script from "./CalendarDashboardStatus.vue?vue&type=script&lang=js"
export * from "./CalendarDashboardStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports